export default "__VITE_ASSET__BPmj7yYn__"